// extracted by mini-css-extract-plugin
module.exports = {"footer":"_2T1Vm5","image":"_3GqHM5","icons":"_3RPZzq","icon":"_36VDsF"};